import { ViewChild } from '@angular/core';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ElementRef } from '@angular/core';

@Component({
  selector: 'app-quick-search',
  templateUrl: './quick-search.component.html',
  styleUrls: ['./quick-search.component.css']
})
export class QuickSearchComponent {
  @ViewChild('searchInput') private inputElement: ElementRef;
  searchQuery: string;
  @Output() search = new EventEmitter<string | number>();
  @Output() reset = new EventEmitter<void>();
  displayError = false;

  constructor(private el: ElementRef) {}

  searchBtn() {
    this.displayError = this.searchQuery?this.searchQuery.length < 3:false;
    this.search.emit(this.searchQuery);
  }

  /** Clear the search input and error state. Call from parent when resetting search. */
  clearSearch() {
    this.searchQuery = '';
    this.displayError = false;
  }

  onReset() {
    this.clearSearch();
    this.reset.emit();
  }

  handleKeyDown(event: any) {
    if (event.event.key === 'Enter') {
      this.searchBtn();
    }
  }
}
